import React, { Fragment } from "react";
import { List, Divider } from "@material-ui/core";

import { Activity } from "../../../api/services";
import { useActivityGroups } from "../hooks/useActivityGroups";
import { ActivityGroup } from "./ActivityGroup";

export const ActivityList: React.FC<{
  activities: Activity[];
}> = ({ activities }) => {
  const { groups, headers } = useActivityGroups(activities);
  return (
    <List disablePadding component="section">
      {headers.map((header, index) => (
        <Fragment key={`activity-group-${header}`}>
          {index !== 0 && <Divider />}
          <ActivityGroup header={header} activities={groups[header]} />
        </Fragment>
      ))}
    </List>
  );
};
